import { postAPI } from "../../api"
import { REACT_APP_CANDIDATEFILTER, REACT_APP_JOB } from "../../utils/common"



export async function getCandidates(tabName: string,  pageSize: number, pageNumber: number, searchValue: string, body?: any){
    const Details = postAPI( REACT_APP_CANDIDATEFILTER + `/candidate-filter?page=${pageNumber}&size=${pageSize}&tab=${tabName}&search=${searchValue}`, body)
    return Details
}

export async function getProviderPositions(searchValue: string, page: number, pageSize: number, providerId: string, tab?: string, data?: any) {
    const Details = postAPI( REACT_APP_JOB + `/provider-position-filter/${providerId}?tab=${tab}&search=${searchValue}&page=${page}&size=${pageSize}`, data)
    return Details
}

export async function applyCandidateToJob(body: any) {
    const Details = postAPI( REACT_APP_JOB + '/candidate-job-application', body)
    return Details
}

